<template>
  <div>
    <!-- 기본정보 -->
    <div>
      <p class="title mt-5 mb-5">기본정보</p>

      <div class="w-full grid" style="grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem">
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">분야명</div>
          <ml-input class="w-full flex-1" v-model="projectInfo.field_name" placeholder="자동입력" readonly />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">소속명</div>
          <ml-input class="w-full flex-1" v-model="myInfo.department" placeholder="자동입력" readonly />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">부서명</div>
          <ml-input class="w-full flex-1" v-model="companyInfo.com_name" placeholder="자동입력" readonly />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">직책</div>
          <ml-input class="w-full flex-1" v-model="companyInfo.director" placeholder="자동입력" readonly />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">작성자</div>
          <ml-input class="w-full flex-1" v-model="myInfo.name" placeholder="자동입력" readonly />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">작성일</div>
          <date-selector class="w-full flex-1" :value="today" placeholder="자동입력" readonly />
        </div>
      </div>
    </div>

    <!-- 신규 현장 개요 -->
    <div>
      <p class="title mt-5 mb-5">신규 현장 개요</p>
      <div class="w-full grid" style="grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem">
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">현장명</div>
          <ml-input class="w-full flex-1" v-model="form.field_name" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">담당 주무관</div>
          <ml-input class="w-full flex-1" v-model="form.director_name" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">사업기간</div>
          <div class="flex items-center gap-3">
            <date-selector v-model="form.work_begin_at" class="w-full flex-1" placeholder="선택" />
            <span>~</span>
            <date-selector v-model="form.work_end_at" class="w-full flex-1" placeholder="선택" />
          </div>
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">사업금액</div>
          <comma-input class="w-full flex-1" v-model="form.deposit_amount" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">현장 주소</div>
          <ml-input class="w-full flex-1" v-model="form.address" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">현장 연락처</div>
          <ml-input class="w-full flex-1" v-model="form.phone" placeholder="입력필드" />
        </div>
      </div>
    </div>

    <!-- 수급업체 정보 -->
    <FieldWorkplaceTable v-model="form.infoDatas" />
  </div>
</template>

<script>
import moment from "moment";
import FieldWorkplaceTable from "@/components/FieldWorkplaceTable.vue";
import DateSelector from "@/components/selector/DateSelector";

export default {
  components: {
    FieldWorkplaceTable,
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },

  data() {
    return {
      form: {
        field_name: "", // 현장명
        director_name: "", // 담당 주무관
        work_begin_at: "", // 사업기간 시작
        work_end_at: "", // 사업기간 종료
        deposit_amount: "", // 사업금액
        address: "", //현장 주소
        phone: "", // 현장 연락처
        infoDatas: [],
      },
    };
  },
  computed: {
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    companyInfo() {
      return this.$store.state.auth.companyInfo;
    },
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
    postId() {
      return this.$route.params.postId;
    },
    today() {
      return moment(new Date()).format("YYYY-MM-DD");
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 18px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0px;
    border-radius: 100%;
  }

  & > span {
    color: #696d71;
  }
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
</style>
